import type { RouteObject } from 'react-router-dom'

import { ACCOUNTS_ROUTES } from '@/modules/accounts/routes/accountsRouteConfig'
import { ACTION_PLAN_ROUTES } from '@/modules/actionPlan/routes/actionPlanRouteConfig'
import { ADMIN_ROUTES } from '@/modules/admin/routes/adminRouteConfig'
import { ADVISORS_USERS_ROUTES } from '@/modules/advisors/users/routes/advisorsUsersRouteConfig'
import { ADVISORS_LIST_ROUTES } from '@/modules/advisorsPage/routes/advisorsListRouteConfig'
import { BUDGET_ROUTES } from '@/modules/budget/routes/budgetRouteConfig'
import { COMMON_ROUTES } from '@/modules/common/routes/commonRouteConfig'
import { DASHBOARD_ROUTES } from '@/modules/dashboard/routes/dashboardRouteConfig'
import { EMPLOYER_ROUTES } from '@/modules/employer/routes/employerRouteConfig'
import { EMPLOYER_ADVISORS_ROUTES } from '@/modules/employerAdvisors/routes/employerAdvisorsRouteConfig'
import { EMPLOYER_USERS_ROUTES } from '@/modules/employerUsers/routes/employerUsersRouteConfig'
import { HOME_ROUTES } from '@/modules/home/routes/homeRouteConfig'
import { LOGIN_ROUTES } from '@/modules/login/routes/loginRouteConfig'
import { NET_WORTH_ROUTES } from '@/modules/netWorth/routes/netWorthRouteConfig'
import {
  ONBOARDING_EDIT_ROUTES,
  ONBOARDING_ROUTES,
} from '@/modules/onboarding/routes/onboardingRouteConfig'
import { PAGES_ROUTES } from '@/modules/page/routes/pageRouteConfig'
import { PASSWORD_RESET_ROUTES } from '@/modules/passwordReset/routes/passwordResetRouteConfig'
import { PROFILE_ROUTES } from '@/modules/profile/routes/profileRouteConfig'
import { REGISTER_ROUTES } from '@/modules/register/routes/registerRouteConfig'
import { SUPPORT_ROUTES } from '@/modules/support/routes/supportRouteConfig'
import { VERIFY_ROUTES } from '@/modules/verify/routes/verifyRouteConfig'

export const DEFAULT_LAYOUT_PUBLIC_ROUTES: RouteObject[] = [
  ...LOGIN_ROUTES,
  ...REGISTER_ROUTES,
  ...PASSWORD_RESET_ROUTES,
  ...COMMON_ROUTES,
  ...VERIFY_ROUTES,
  ...HOME_ROUTES,
]

export const PAGES_LAYOUT_PUBLIC_ROUTES: RouteObject[] = [...PAGES_ROUTES]

export const ADMIN_PRIVATE_ROUTES: RouteObject[] = [...ADMIN_ROUTES]

export const ADVISORS_PRIVATE_ROUTES: RouteObject[] = [...ADVISORS_USERS_ROUTES]

export const EMPLOYER_PRIVATE_ROUTES: RouteObject[] = [
  ...EMPLOYER_ROUTES,
  ...EMPLOYER_ADVISORS_ROUTES,
  ...EMPLOYER_USERS_ROUTES,
]

export const AUTHENTICATED_LAYOUT_PRIVATE_ROUTES: RouteObject[] = [
  ...DASHBOARD_ROUTES,
  ...NET_WORTH_ROUTES,
  ...ACCOUNTS_ROUTES,
  ...ONBOARDING_EDIT_ROUTES,
  ...ADVISORS_LIST_ROUTES,
  ...BUDGET_ROUTES,
  ...ACTION_PLAN_ROUTES,
]

export const USERS_PRIVATE_ROUTES: RouteObject[] = [
  ...PROFILE_ROUTES,
  ...SUPPORT_ROUTES,
]

export const FULLWIDTH_LAYOUT_PRIVATE_ROUTES: RouteObject[] = [
  ...ONBOARDING_ROUTES,
]
